import React, { useState } from 'react';
import { Input, Button, Modal, Spin } from 'antd';
import { useComplaintCauseForm } from './hooks/useComplaintCauseForm';

const { TextArea } = Input;

const N101Form: React.FC = () => {
  const {
    mode, isEditing, loading, records, current, currentIdx,
    code, setCode, descCn, setDescCn, descEn, setDescEn,
    navFirst, navPrev, navNext, navLast,
    startAdd, startEdit, cancel, save, doDelete, quickSearch,
  } = useComplaintCauseForm();

  const [searchText, setSearchText] = useState('');
  const handleDelete = () => {
    if (!current) return;
    Modal.confirm({
      title: '確認刪除', content: `確定要刪除「${current.fn01_02}」？`,
      okText: '刪除', okType: 'danger', cancelText: '取消', onOk: doDelete,
    });
  };
  const modeLabel = mode === 'add' ? '新增' : mode === 'edit' ? '修改' : '瀏覽';

  return (
    <Spin spinning={loading}>
      <div className="max-w-2xl mx-auto p-6">
        <h2 className="text-xl font-bold mb-4">
          客訴原因設定 (pwn101f1)
          <span className="ml-3 text-sm font-normal text-gray-500">
            [{modeLabel}] {records.length > 0 ? `${currentIdx + 1} / ${records.length}` : '無資料'}
          </span>
        </h2>
        <div className="flex items-center gap-2 mb-4">
          <Input placeholder="代號查詢" value={searchText} onChange={e => setSearchText(e.target.value)}
            onPressEnter={() => searchText.trim() && quickSearch(searchText.trim())}
            disabled={isEditing} style={{ width: 150 }} maxLength={3} />
          <Button onClick={() => searchText.trim() && quickSearch(searchText.trim())} disabled={isEditing}>查詢</Button>
        </div>
        <div className="flex items-center gap-1 mb-4">
          <Button size="small" onClick={navFirst} disabled={isEditing || !records.length}>|&lt;</Button>
          <Button size="small" onClick={navPrev} disabled={isEditing || currentIdx <= 0}>&lt;</Button>
          <Button size="small" onClick={navNext} disabled={isEditing || currentIdx >= records.length - 1}>&gt;</Button>
          <Button size="small" onClick={navLast} disabled={isEditing || !records.length}>&gt;|</Button>
        </div>
        <div className="space-y-4 mb-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">原因代號 (FN01_02)</label>
            <Input value={code} onChange={e => setCode(e.target.value)} maxLength={3}
              disabled={mode !== 'add'} style={{ width: 100 }} placeholder="3碼" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">中文客訴原因 (FN01_11)</label>
            <TextArea value={descCn} onChange={e => setDescCn(e.target.value)}
              disabled={!isEditing} rows={4} style={{ width: 500 }} />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">英文客訴原因 (FN01_12)</label>
            <TextArea value={descEn} onChange={e => setDescEn(e.target.value)}
              disabled={!isEditing} rows={4} style={{ width: 500 }} />
          </div>
        </div>
        {current && mode === 'browse' && (
          <div className="text-xs text-gray-400 mb-6">
            建立者: {current.fn01_91} | 建立日期: {current.fn01_92 || '-'} | 修改者: {current.fn01_93}
          </div>
        )}
        <div className="flex items-center gap-2">
          {!isEditing ? (
            <>
              <Button type="primary" onClick={startAdd}>新增</Button>
              <Button onClick={startEdit} disabled={!current}>修改</Button>
              <Button danger onClick={handleDelete} disabled={!current}>刪除</Button>
            </>
          ) : (
            <>
              <Button type="primary" onClick={save}>儲存</Button>
              <Button onClick={cancel}>取消</Button>
            </>
          )}
        </div>
      </div>
    </Spin>
  );
};

export default N101Form;
